import React, { useRef } from 'react';
import { useTheme } from '../../ThemeContext';
import { Link } from 'react-router-dom';
import { ChatDots, ChevronLeft, ChevronRight, PlayCircle } from 'react-bootstrap-icons';

const videos = [
  { id: 'ios', title: 'Как установить на iOS', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239401&hd=2' },
  { id: 'android', title: 'Как установить на Android', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239402&hd=2' },
  { id: 'auth', title: 'Как авторизоваться', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239403&hd=2' },
  { id: 'feed', title: 'Элементы ленты скидок', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239404&hd=2' },
  { id: 'filters', title: 'Объяснение фильтров', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239405&hd=2' },
  { id: 'watchlist', title: 'Объяснение листа отслеживания', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239406&hd=2' },
];

const VideosPage = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const railRef = useRef(null);
  const supportTelegramUrl = 'https://t.me/SaleW_Support';
  const supportMaxUrl = 'https://max.ru/u/f9LHodD0cOLkybkMaACuMPTooxWoTrXIaccAneeGAfvHKvf7aKrFOq6HAvA';

  const scrollVideos = (direction) => {
    const rail = railRef.current;
    if (!rail) return;
    const amount = Math.max(rail.clientWidth * 0.82, 260);
    rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  return (
    <div className={`min-vh-100 sb-videos videos-safe-top ${isDark ? 'sb-dark' : 'sb-light'} scrollable`}>
      <div className={`main-status-glass ${isDark ? 'main-status-glass--dark' : 'main-status-glass--light'}`} aria-hidden="true" />
      <style>{`
        :root{
          --sb-maxw: 87.5rem;
          --sb-bg-light:#eef5f4; --sb-bg-dark:#101924;
          --sb-heading-light:#0f172a; --sb-heading-dark:#fff;
          --sb-text-light:#1f2937; --sb-text-dark:#e5e7eb;
          --sb-muted-light:#475569; --sb-muted-dark:#9aa4b2;
          --sb-accent:#6db5f0; --sb-accent-2:#6fcf97;
          --sb-border:rgba(255,255,255,0.12);
          --sb-card-light:rgba(255,255,255,0.62);
          --sb-card-dark:rgba(34,49,64,0.72);
        }
        .sb-videos{
          min-height:100dvh;
          height:100dvh;
          max-height:100dvh;
          overflow-y:auto;
          background:var(--sb-bg-light);
          color:var(--sb-text-light);
          --sb-safe-top:max(env(safe-area-inset-top,0px),env(safe-area-max-inset-top,0px),var(--ios-standalone-top-fallback,0px));
          --sb-header-height:58px;
          background:
            radial-gradient(circle at 10% 10%, rgba(109,181,240,.26), transparent 34%),
            linear-gradient(135deg, rgba(226,243,239,.96), rgba(240,247,255,.92));
        }
        .sb-dark.sb-videos{
          background:
            radial-gradient(circle at 12% 0%, rgba(109,181,240,.16), transparent 36%),
            linear-gradient(135deg, #101924, #162333 58%, #101924);
          color:var(--sb-text-dark);
        }

        .sb-v-body{
          max-width:var(--sb-maxw);
          margin:0 auto;
          padding-top:calc(var(--sb-safe-top) + var(--sb-header-height) + 24px);
          padding-bottom:calc(28px + env(safe-area-inset-bottom,0px));
        }
        .sb-v-head{
          max-width:var(--sb-maxw);
          margin:0 auto;
          padding:18px 22px 8px;
          display:flex;
          align-items:flex-start;
          justify-content:space-between;
          gap:16px;
        }
        .sb-v-badge{
          display:inline-flex;
          align-items:center;
          gap:7px;
          padding:7px 11px;
          border-radius:999px;
          font-weight:800;
          font-size:12px;
          color:#2d5578;
          background:rgba(255,255,255,.68);
          border:1px solid rgba(185,209,232,.55);
          backdrop-filter:blur(14px) saturate(1.1);
          -webkit-backdrop-filter:blur(14px) saturate(1.1);
          box-shadow:0 8px 18px rgba(28,54,84,.12);
        }
        .sb-dark .sb-v-badge{
          color:#def0ff;
          background:rgba(39,55,72,.74);
          border-color:rgba(165,190,216,.38);
          box-shadow:0 8px 18px rgba(0,0,0,.24);
        }
        .sb-v-title{
          font-weight:900;
          font-size:clamp(22px,2.6vw,34px);
          color:var(--sb-heading-light);
          margin:9px 0 4px;
          line-height:1.12;
        }
        .sb-dark .sb-v-title{color:var(--sb-heading-dark);}
        .sb-v-subtitle{
          margin:0;
          color:var(--sb-muted-light);
          font-weight:600;
          font-size:14px;
        }
        .sb-dark .sb-v-subtitle{color:var(--sb-muted-dark);}

        .sb-v-support{
          flex:0 0 auto;
          display:grid;
          gap:8px;
          min-width:190px;
          padding:10px;
          border-radius:18px;
          background:rgba(255,255,255,.52);
          border:1px solid rgba(185,209,232,.48);
          backdrop-filter:blur(16px) saturate(1.1);
          -webkit-backdrop-filter:blur(16px) saturate(1.1);
          box-shadow:0 12px 28px rgba(28,54,84,.12);
        }
        .sb-dark .sb-v-support{
          background:rgba(34,49,64,.68);
          border-color:rgba(165,190,216,.26);
          box-shadow:0 12px 28px rgba(0,0,0,.26);
        }
        .sb-v-support-title{
          display:flex;
          align-items:center;
          gap:7px;
          font-size:13px;
          font-weight:800;
          color:var(--sb-heading-light);
        }
        .sb-dark .sb-v-support-title{color:var(--sb-heading-dark);}
        .sb-v-support-actions{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:8px;
        }
        .sb-v-support-btn{
          min-height:38px;
          border-radius:14px;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          gap:7px;
          text-decoration:none;
          font-weight:800;
          font-size:13px;
          border:1px solid rgba(111,175,229,.52);
          background:rgba(109,181,240,.28);
          color:#2d5578;
          box-shadow:0 8px 18px rgba(28,54,84,.12);
          transition:transform .16s ease, box-shadow .16s ease;
        }
        .sb-dark .sb-v-support-btn{
          color:#def0ff;
          background:rgba(94,146,198,.34);
          border-color:rgba(116,171,227,.5);
          box-shadow:0 8px 18px rgba(0,0,0,.22);
        }
        .sb-v-support-btn:active{transform:scale(.97);}

        .sb-v-carousel-shell{
          position:relative;
          max-width:var(--sb-maxw);
          margin:12px auto 26px;
          padding:0 22px;
        }
        .sb-v-carousel-shell::before,
        .sb-v-carousel-shell::after{
          content:'';
          position:absolute;
          top:0;
          bottom:0;
          width:70px;
          z-index:3;
          pointer-events:none;
        }
        .sb-v-carousel-shell::before{
          left:22px;
          background:linear-gradient(90deg, rgba(238,245,244,.9), rgba(238,245,244,0));
        }
        .sb-v-carousel-shell::after{
          right:22px;
          background:linear-gradient(270deg, rgba(238,245,244,.9), rgba(238,245,244,0));
        }
        .sb-dark .sb-v-carousel-shell::before{
          background:linear-gradient(90deg, rgba(16,25,36,.92), rgba(16,25,36,0));
        }
        .sb-dark .sb-v-carousel-shell::after{
          background:linear-gradient(270deg, rgba(16,25,36,.92), rgba(16,25,36,0));
        }
        .sb-v-rail{
          display:flex;
          gap:16px;
          overflow-x:auto;
          overflow-y:hidden;
          scroll-snap-type:x mandatory;
          scroll-padding:22px;
          padding:8px 38px 20px;
          -webkit-overflow-scrolling:touch;
          overscroll-behavior-x:contain;
        }
        .sb-v-rail::-webkit-scrollbar{height:8px;}
        .sb-v-rail::-webkit-scrollbar-track{
          background:rgba(185,209,232,.28);
          border-radius:999px;
        }
        .sb-v-rail::-webkit-scrollbar-thumb{
          background:rgba(109,181,240,.78);
          border-radius:999px;
        }
        .sb-dark .sb-v-rail::-webkit-scrollbar-track{background:rgba(165,190,216,.18);}
        .sb-dark .sb-v-rail::-webkit-scrollbar-thumb{background:rgba(116,171,227,.72);}

        .sb-card{
          flex:0 0 clamp(270px, 30vw, 390px);
          scroll-snap-align:center;
          border:1px solid rgba(185,209,232,.46);
          border-radius:18px;
          background:var(--sb-card-light);
          padding:12px;
          backdrop-filter:blur(16px) saturate(1.08);
          -webkit-backdrop-filter:blur(16px) saturate(1.08);
          box-shadow:0 14px 30px rgba(28,54,84,.14);
        }
        .sb-dark .sb-card{
          background:var(--sb-card-dark);
          border-color:rgba(165,190,216,.24);
          box-shadow:0 14px 30px rgba(0,0,0,.28);
        }
        .sb-card:first-child{margin-left:8px;}
        .sb-card:last-child{margin-right:8px;}
        .sb-embed{position:relative; width:100%; aspect-ratio:9/16; border-radius:14px; overflow:hidden; background:#000;}
        .sb-iframe{position:absolute; inset:0; width:100%; height:100%; border:0;}
        .sb-title{margin:10px 4px 2px; font-size:15px; font-weight:800; color:var(--sb-heading-light);}
        .sb-dark .sb-title{color:var(--sb-heading-dark);}

        .sb-v-nav-btn{
          position:absolute;
          top:50%;
          transform:translateY(-50%);
          z-index:5;
          width:42px;
          height:42px;
          border-radius:50%;
          border:1px solid rgba(185,209,232,.55);
          background:rgba(255,255,255,.76);
          color:#4e6b86;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          box-shadow:0 10px 22px rgba(28,54,84,.16);
          backdrop-filter:blur(14px) saturate(1.1);
          -webkit-backdrop-filter:blur(14px) saturate(1.1);
          cursor:pointer;
          transition:transform .16s ease, background .16s ease;
        }
        .sb-dark .sb-v-nav-btn{
          background:rgba(39,55,72,.78);
          color:#e9f2fc;
          border-color:rgba(165,190,216,.36);
          box-shadow:0 10px 22px rgba(0,0,0,.28);
        }
        .sb-v-nav-btn:active{transform:translateY(-50%) scale(.96);}
        .sb-v-nav-btn--prev{left:26px;}
        .sb-v-nav-btn--next{right:26px;}

        .sb-header{
          position:fixed;
          top:calc(var(--sb-safe-top) + 8px);
          left:10px;
          right:10px;
          margin:0;
          min-height:var(--sb-header-height);
          z-index:36;
          display:flex;
          align-items:center;
          justify-content:space-between;
          padding:14px 22px;
          border-bottom:1px solid var(--sb-border);
        }
        .sb-light .sb-header{background:rgba(255,255,255,.72);backdrop-filter:blur(16px) saturate(1.1);-webkit-backdrop-filter:blur(16px) saturate(1.1)}
        .sb-dark .sb-header{background:rgba(34,49,64,.72);backdrop-filter:blur(16px) saturate(1.1);-webkit-backdrop-filter:blur(16px) saturate(1.1)}
        .sb-logo{display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit;font-weight:800;letter-spacing:.2px;font-size:18px}
        .sb-logo-img{width:36px;height:36px;border-radius:11px;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));flex:0 0 36px}

        @media (max-width:768px){
          .sb-v-body{
            padding-top:calc(var(--sb-safe-top) + var(--sb-header-height) + 24px);
            padding-bottom:18px;
          }
          .sb-v-head{
            display:block;
            padding:14px 16px 6px;
          }
          .sb-v-support{
            margin-top:12px;
            min-width:0;
          }
          .sb-v-carousel-shell{padding:0 0 0 14px;}
          .sb-v-carousel-shell::before{display:none;}
          .sb-v-carousel-shell::after{
            right:0;
            width:58px;
          }
          .sb-v-rail{
            padding:8px 56px 18px 0;
            scroll-padding-left:0;
          }
          .sb-card{
            flex-basis:min(78vw, 330px);
            scroll-snap-align:start;
          }
          .sb-v-nav-btn{
            width:38px;
            height:38px;
          }
          .sb-v-nav-btn--prev{left:10px;}
          .sb-v-nav-btn--next{right:10px;}
          .sb-header{padding:12px 16px}
          .sb-logo span{font-size:16px}
        }
      `}</style>

      <header className="sb-header">
        <Link className="sb-logo" to="/">
          <img className="sb-logo-img" src="android-icon-36x36.png" alt="Salew Bot" width={36} height={36} />
          <span>Salew Bot</span>
        </Link>
      </header>

      <div className="sb-v-body">
        <div className="sb-v-head">
          <div>
            <span className="sb-v-badge"><PlayCircle size={15} /> Видеопомощь</span>
            <h1 className="sb-v-title">Как пользоваться Salew Bot</h1>
            <p className="sb-v-subtitle">Короткие ролики по установке, входу, ленте скидок, фильтрам и листу отслеживания.</p>
          </div>
          <div className="sb-v-support" aria-label="Поддержка">
            <div className="sb-v-support-title">
              <ChatDots size={16} />
              Поддержка
            </div>
            <div className="sb-v-support-actions">
              <a className="sb-v-support-btn" href={supportTelegramUrl} target="_blank" rel="noreferrer">Telegram</a>
              <a className="sb-v-support-btn" href={supportMaxUrl} target="_blank" rel="noreferrer">MAX</a>
            </div>
          </div>
        </div>

        <div className="sb-v-carousel-shell">
          <button
            type="button"
            className="sb-v-nav-btn sb-v-nav-btn--prev"
            onClick={() => scrollVideos(-1)}
            aria-label="Предыдущее видео"
          >
            <ChevronLeft size={22} />
          </button>
          <div className="sb-v-rail" ref={railRef}>
            {videos.map(v => (
              <article className="sb-card" key={v.id}>
                <div className="sb-embed">
                  <iframe
                    className="sb-iframe"
                    src={`${v.src}&autoplay=0`}
                    title={v.title}
                    loading="lazy"
                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                    allowFullScreen
                  />
                </div>
                <h3 className="sb-title">{v.title}</h3>
              </article>
            ))}
          </div>
          <button
            type="button"
            className="sb-v-nav-btn sb-v-nav-btn--next"
            onClick={() => scrollVideos(1)}
            aria-label="Следующее видео"
          >
            <ChevronRight size={22} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideosPage;
